export enum IssueUrgency {
  Low = 'Low',
  Moderate = 'Moderate',
  Urgent = 'Urgent',
  Critical = 'Critical',
  Monitor = 'Monitor',
}

export const urgencyOrder = {
  [IssueUrgency.Critical]: 1,
  [IssueUrgency.Urgent]: 2,
  [IssueUrgency.Moderate]: 3,
  [IssueUrgency.Low]: 4,
  [IssueUrgency.Monitor]: 5,
};

export interface Issue {
  id: string;
  propertyId: string;
  title: string;
  category: string;
  description: string;
  urgency: IssueUrgency;
  costEstimateMin?: number;
  costEstimateMax?: number;
  projectTimelineMinDays?: number;
  projectTimelineMaxDays?: number;
  proposedBid?: string;
  resolved?: boolean;
  currencyCode?: string;
  currencySymbol?: string;
  componentCategory?: string;
  component?: string;
  trade?: string;
  /** Source report document type (e.g. 'GHI', 'ROOF', 'PEST'). Set by the issues API. */
  reportType?: string;
  /** Who furnished the inspection report — 'seller' or 'buyer'. Set by the issues API. */
  source?: 'seller' | 'buyer';
}
